<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" lg="6">
        <v-row no-gutters>
          <v-col cols="12" md="4" class="pr-1">
            <v-autocomplete
              v-model="state"
              placeholder="Select State"
              dense
              :items="states"
              @change="loadDealerContacts"
              :disabled="isAwarded"
              outlined
              item-text="name"
              item-value="name"
            ></v-autocomplete>
          </v-col>
          <v-col cols="6" md="4" class="pl-1">
            <v-text-field
              v-model="zip"
              placeholder="Enter Zip Code"
              dense
              outlined
              :disabled="isAwarded"
            ></v-text-field>
          </v-col>
          <v-col cols="6" md="4" class="pl-1">
            <v-select
              v-model="radius"
              placeholder="Select Radius"
              dense
              :disabled="isAwarded"
              :items="[
                '25 mi',
                '50 mi',
                '75 mi',
                '100 mi',
                '150 mi',
                '200 mi',
                'All'
              ]"
              outlined
            ></v-select>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        cols="12"
        md="4"
        lg="4"
        xl="3"
        offset-md="2"
        offset-lg="2"
        offset-xl="3"
        class="text-md-right"
      >
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="date"
              placeholder="Expected Delivery Date"
              persistent-hint
              prepend-inner-icon="mdi-calendar"
              readonly
              outlined
              :disabled="isAwarded"
              dense
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="date"
            :disabled="isAwarded"
            no-title
            @input="dateMenu = false"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-card v-if="!isLoading">
      <v-card-text>
        <div v-if="!dealers.length" class="text-center">
          <strong>No Dealers found...</strong>
        </div>
        <div v-for="dealer in dealers" :key="dealer.dealer_company">
          <v-hover v-slot="{ hover }">
            <v-card :elevation="hover ? 12 : 0" class="px-2 cursor-pointer">
              <v-row align-md="center">
                <v-col cols="12" md="8" lg="9">
                  <div class="d-flex align-center">
                    <div>
                      <v-img
                        width="80"
                        height="60"
                        :src="require(`@/assets/images/BMC.png`)"
                        contain
                      ></v-img>
                    </div>
                    <div class="ml-1">
                      <h6 class="primary--text pb-0 mb-0">
                        <strong>{{ dealer.dealer_company }}</strong>
                      </h6>
                      <div>
                        <strong>Phone: </strong>
                        <span>{{ dealer.address.phone }} </span>
                      </div>
                      <div>
                        <strong>Address: </strong>
                        <span v-if="dealer.address.add_line_1"
                          >{{ dealer.address.add_line_1 }},
                        </span>
                        <span v-if="dealer.address.add_line_2"
                          >{{ dealer.address.add_line_2 }},
                        </span>
                        <span v-if="dealer.address.add_line_3"
                          >{{ dealer.address.add_line_3 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </v-col>
                <v-col cols="12" md="4" lg="3" class="text-right text-md-left">
                  <v-btn
                    depressed
                    color="primary"
                    class="white--text"
                    @click="sendRequest(dealer)"
                    ><v-icon color="white" size="18" class="mr-1"
                      >mdi-send</v-icon
                    >
                    RFQ</v-btn
                  >
                </v-col>
              </v-row>
            </v-card>
          </v-hover>
          <v-divider></v-divider>
        </div>
      </v-card-text>
    </v-card>

    <SendRequest
      v-if="requestModal && dealer"
      :dialog="requestModal"
      :dealer="dealer"
      @close="requestModal = false"
      @refresh="loadDealerContacts"
    />
  </div>
</template>

<script>
import SendRequest from "@/components/rfq/SendRequest";
import states from "@/configs/states.json";
import { mapState } from "vuex";
export default {
  components: {
    SendRequest
  },
  props: {
    schedule: {
      type: Object,
      default: null
    }
  },
  computed: {
    ...mapState({
      dealerList: state => state.rfq.dealers,
      projectRfq: state => state.rfq.project_rfqs
    }),

    dealers() {
      let dealersArray = [];
      // Get the dealers that are not in the rfq
      if (this.dealerList && this.dealerList.length > 0 && !this.isAwarded()) {
        if (this.projectRfq && this.projectRfq.length > 0) {
          this.dealerList.forEach(dealer => {
            const rfqDealer = this.projectRfq.find(
              rfq => rfq.dealer.email === dealer.email
            );

            if (!rfqDealer) {
              dealersArray.push(dealer);
            }
          });
        } else {
          dealersArray = [...this.dealerList];
        }
      }

      if (dealersArray.length > 0) {
        let uniqueDealers = [
          ...new Map(
            dealersArray.map(dealer => [dealer["email"], dealer])
          ).values()
        ];

        return uniqueDealers;
      }
      // if (
      //   this.dealerList &&
      //   this.dealerList.length > 0 &&
      //   this.projectRfq &&
      //   this.projectRfq.length > 0
      // ) {
      //   this.dealerList.forEach(dealer => {
      //     const rfqDealer = this.projectRfq.find(
      //       rfq => rfq.dealer.email === dealer.email
      //     );

      //     if (rfqDealer) {
      //       dealersArray.push(dealer);
      //     }
      //   });
      // }

      return dealersArray;
    }
  },
  mounted() {
    this.loadDealerContacts();
  },
  methods: {
    isAwarded() {
      if (this.schedule && this.schedule.status === "awarded") {
        return true;
      }

      return false;
    },
    loadDealerContacts() {
      this.requestModal = false;
      if (this.state) {
        const payload = {
          state: this.state.toLowerCase(),
          zip: this.zip,
          radius: this.radius,
          expected_delivery_date: this.date
        };

        this.isLoading = true;
        // let loader = this.$loading.show();

        this.$store
          .dispatch("rfq/getDealerContacts", payload)
          .then(async () => {
            await this.loadRFQs();
            // this.dealers = [...resp.dealers];
          })
          .finally(() => {
            this.isLoading = false;
            // loader.hide();
          });
      }
    },

    async loadRFQs() {
      const payload = {
        project_id: this.$route.params.id,
        schedule: this.$route.params.name
      };

      await this.$store.dispatch("rfq/getProjectRFQs", payload);
    },
    sendRequest(dealer) {
      this.dealer = { ...dealer };
      this.requestModal = true;
    }
  },
  data() {
    return {
      isLoading: false,
      states,
      dateMenu: false,
      state: "Utah",
      zip: null,
      radius: null,
      date: null,
      delivery_date: null,
      requestModal: false,
      sentModal: false,
      quotesModal: false,
      dealer: null
    };
  }
};
</script>
